import { createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, openBlock as _openBlock } from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
      },
      [
        _createElementVNode("path", {
          fill: "currentColor",
          "fill-rule": "evenodd",
          d: "M19 22c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3H5C3.34 2 2 3.34 2 5v14c0 1.66 1.34 3 3 3zM14.83 9.758c-1.35.072-2.526.48-3.48 1.405-.964.937-1.405 2.08-1.282 3.497l-.41-.053c-.374-.05-.728-.097-1.085-.125a.93.93 0 0 0-.508.083c-.345.198-.681.41-1.049.643l-.406.255q.051-.23.094-.444c.055-.267.106-.517.18-.76.083-.274.044-.424-.207-.603-1.612-1.143-2.298-2.855-1.785-4.618.474-1.628 1.634-2.62 3.212-3.134 2.153-.703 4.58.017 5.884 1.723.474.614.764 1.311.842 2.13Zm-6.212-.552a.625.625 0 0 0-.597-.625.606.606 0 0 0-.63.586.594.594 0 0 0 .59.619.614.614 0 0 0 .637-.58m3.24-.62a.62.62 0 0 0-.608.614.614.614 0 0 0 .624.597.6.6 0 0 0 .603-.614.6.6 0 0 0-.62-.596Zm5.614 9.393c-.283-.149-.558-.293-.846-.324-.246-.026-.498.046-.753.12-.178.05-.357.102-.535.12-1.328.134-2.516-.234-3.492-1.138-1.862-1.723-1.595-4.367.558-5.778 1.913-1.254 4.724-.836 6.073.904 1.177 1.517 1.038 3.536-.396 4.813-.418.368-.568.675-.3 1.16.034.065.047.137.061.212l.022.106a6 6 0 0 1-.392-.195m-4.477-4.518a.504.504 0 0 0 .508-.48.505.505 0 1 0-1.01-.005.504.504 0 0 0 .502.485m3.14-1.004a.507.507 0 0 0-.502.48.495.495 0 1 0 .987.04.49.49 0 0 0-.485-.52",
          "clip-rule": "evenodd",
        }),
      ]
    )
  );
}
